import React, { useCallback, useState } from 'react';
import { Circle, Group, Stage, Layer, Rect, Line} from 'react-konva';
import {
    getXPositionFromStep,
    getYPositionFromVolume
} from './positionUtils.js';

export default function VolumeGuidePoint(props) {
    if (props.guidePoint === undefined) {
        return (<Rect x={0} y={0} width={0} height={0}></Rect>);
    }

    return (
         <circle
           onMouseLeave={props.onMouseLeave}
           onMouseDown={props.onClick}
           cx={getXPositionFromStep(props.guidePoint.step, props.resolution, props.xScale)}
           cy={getYPositionFromVolume(props.guidePoint.value)}
           r={2}
           fill={'blue'}
           stroke={'blue'}
           strokeWidth={2} />
    );
}
